var r=function(r,n,t){return r?-1===t?n-1:t===n?0:t:t};export{r as correctNextSlideIndex};
